import { render, staticRenderFns } from "./institucion.vue?vue&type=template&id=5afb9584"
import script from "./institucion.vue?vue&type=script&lang=js"
export * from "./institucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports